<ul class="m-0 p-0 list-none">
  <li class="mb-2 font-medium" (click)="toggle(item); $event.preventDefault()" *ngFor="let item of ['primary', 'it.mama']">
    <a3l-ui-checkbox outlined [value]="item" [checked]="selection.isSelected(item)" [disabled]="!selection.isSelected(item)" [ngSwitch]="item">
      <span translate *ngSwitchCase="'primary'">Podstawowy</span>
      <span *ngSwitchCase="'it.mama'">IT.Mama</span>
    </a3l-ui-checkbox>
  </li>
</ul>
